module.exports = __webpack_public_path__ + "static/media/BoxPlotQ8_3.6cdea8b0.svg";